import habitat from 'preact-habitat';
import Widget from './components/Widget';

const { render } = habitat(Widget);

render({
  selector: '#program-finder', // Searches and mounts in <div class="some-class"></div>
  defaultProps: undefined, // Default props for all widgets
  inline: false,
  clean: false,
  clientSpecified: false
});